import { Modal, Text } from '@salecycle/ui-component-library';
import React, { FC, useEffect, useState } from 'react';

export interface IConfirmationModalProps {
  cancelButtonLabel: string;
  description: string;
  heading: string;
  isOpen: boolean;
  okButtonLabel: string;
  onCancelButtonClicked: () => void;
  onCloseButtonClicked: () => void;
  onOkButtonClicked: () => void;
}

export const ConfirmationModal: FC<IConfirmationModalProps> = ({
  cancelButtonLabel,
  description,
  heading,
  isOpen,
  okButtonLabel,
  onCancelButtonClicked,
  onCloseButtonClicked,
  onOkButtonClicked,
}) => {
  const [okButtonDisabled, setOkButtonDisabled] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setOkButtonDisabled(false);
    }
  }, [isOpen]);

  const handleOkButtonClicked = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.preventDefault();

    setOkButtonDisabled(true);
    onOkButtonClicked();
  };

  return (
    <Modal
      cancelButtonLabel={cancelButtonLabel}
      heading={heading}
      isOpen={isOpen}
      okButtonDisabled={okButtonDisabled}
      okButtonLabel={okButtonLabel}
      onCancelButtonClicked={onCancelButtonClicked}
      onCloseButtonClicked={onCloseButtonClicked}
      onOkButtonClicked={handleOkButtonClicked}
      variation="clean"
    >
      <Text size={14}>{description}</Text>
    </Modal>
  );
};

export default ConfirmationModal;
